import EmailFooterV2 from '../components/FooterV2';

interface SubscriptionItem {
  planName: string;
  planDescription: string;
  price: string;
  billingPeriod: string;
  nextBillingDate: string;
}

interface OrderConfirmationEmailV2Props {
  customerName?: string;
  items?: SubscriptionItem[];
  transactionId?: string;
  purchaseDate?: string;
  email?: string;
  total?: string;
  companyName?: string;
}

export default function OrderConfirmationEmailV2({
  customerName = "João Silva",
  items = [
    {
      planName: "Plano Profissional",
      planDescription: "Acesso completo a todas as funcionalidades premium",
      price: "R$ 99,95",
      billingPeriod: "Mensal",
      nextBillingDate: "14 Abr, 2025",
    },
    {
      planName: "Módulo Adicional - Analytics",
      planDescription: "Relatórios avançados e análise de dados",
      price: "R$ 49,95",
      billingPeriod: "Mensal",
      nextBillingDate: "14 Abr, 2025",
    },
  ],
  transactionId = "2342",
  purchaseDate = "14 Mar, 2025",
  email = "joao.silva@email.com",
  total = "R$ 149,90",
  companyName = "Trivium"
}: OrderConfirmationEmailV2Props) {
  return (
    <div style={{ margin: 0, padding: 0, fontFamily: "Arial, sans-serif", backgroundColor: "#f7f7f7" }}>
      {/* Responsive CSS Styles */}
      <style dangerouslySetInnerHTML={{
        __html: `
          @media only screen and (max-width: 600px) {
            .email-container { width: 100% !important; max-width: 100% !important; border-radius: 0 !important; }
            .body-content { padding: 24px 20px !important; }
            .header { padding: 16px !important; }
            .logo { width: 100px !important; }
            .title { font-size: 20px !important; margin: 12px 0 4px !important; }
            .subtitle { font-size: 14px !important; margin: 0 0 20px !important; }
            .badge { font-size: 12px !important; padding: 6px 12px !important; }
            .card { padding: 12px !important; margin-bottom: 6px !important; }
            .card-label { font-size: 11px !important; }
            .card-value { font-size: 14px !important; }
            .section-title { font-size: 16px !important; margin: 20px 0 8px !important; }
            .info-box { padding: 16px !important; }
            .info-box h3 { font-size: 15px !important; }
            .info-box p { font-size: 13px !important; }
            .btn { display: block !important; width: 100% !important; text-align: center !important; margin-bottom: 8px !important; }
            .btn-primary { padding: 14px 16px !important; font-size: 15px !important; }
            .contact-box { padding: 16px !important; }
            .contact-title { font-size: 15px !important; }
            .contact-info { font-size: 13px !important; }
            .footer { padding: 20px 16px !important; }
            .footer-logo { width: 70px !important; }
            .social-icons { justify-content: center !important; gap: 20px !important; }
            .social-icon { width: 24px !important; height: 24px !important; }
            .item-row { display: block !important; }
            .item-details { width: 100% !important; margin-bottom: 8px !important; }
            .item-price { width: 100% !important; text-align: left !important; }
          }
          @media only screen and (max-width: 480px) {
            .body-content { padding: 20px 16px !important; }
            .title { font-size: 18px !important; }
            .subtitle { font-size: 13px !important; }
            .card { padding: 10px !important; }
            .card-label { font-size: 10px !important; }
            .card-value { font-size: 13px !important; }
            .section-title { font-size: 15px !important; }
            .info-box { padding: 14px !important; }
            .btn-primary { padding: 12px 14px !important; font-size: 14px !important; }
            .social-icons { gap: 16px !important; }
            .social-icon { width: 22px !important; height: 22px !important; }
          }
        `
      }} />
      
      <table
        width="100%"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ backgroundColor: "#f7f7f7", padding: "40px 0" }}
      >
        <tbody>
          <tr>
            <td align="center">
              <table
                className="email-container"
                width={600}
                border={0}
                cellSpacing={0}
                cellPadding={0}
                style={{ 
                  backgroundColor: "#ffffff", 
                  borderRadius: "12px", 
                  overflow: "hidden",
                  maxWidth: "600px",
                  margin: "0 auto"
                }}
              >
                <tbody>
                  {/* Header */}
                  <tr>
                    <td 
                      className="header"
                      align="center" 
                      style={{ 
                        backgroundColor: "#1F1746", 
                        padding: "20px",
                        textAlign: "center"
                      }}
                    >
                      <div style={{ textAlign: "center", width: "100%" }}>
                        <img
                          className="logo"
                          src="https://asset.brandfetch.io/idNdb_MPJ2/idFGj2lq6u.png?c=1dxbfHSJFAPEGdCLU4o5B"
                          alt="Logo Trivium"
                          width={120}
                          style={{ 
                            display: "block", 
                            width: "120px", 
                            height: "auto",
                            margin: "0 auto"
                          }}
                        />
                      </div>
                    </td>
                  </tr>

                  {/* Body */}
                  <tr>
                    <td 
                      className="body-content"
                      style={{ 
                        padding: "36px 30px", 
                        color: "#333333"
                      }}
                    >
                      {/* Title */}
                      <div style={{ textAlign: "center", marginBottom: "32px" }}>
                        <span
                          className="badge"
                          style={{
                            backgroundColor: "#fef3c7",
                            color: "#92400e",
                            display: "inline-block",
                            padding: "8px 16px",
                            borderRadius: "999px",
                            fontSize: "13px",
                            fontWeight: 700,
                            marginBottom: "16px"
                          }}
                        >
                          🎉 Pedido confirmado
                        </span>

                        <h1 
                          className="title"
                          style={{ 
                            fontSize: "24px", 
                            margin: "16px 0 6px", 
                            color: "#111111",
                            lineHeight: "1.3"
                          }}
                        >
                          Obrigado pela sua assinatura!
                        </h1>
                        <p 
                          className="subtitle"
                          style={{ 
                            fontSize: "16px", 
                            margin: "0 0 20px", 
                            color: "#555555", 
                            lineHeight: "1.6"
                          }}
                        >
                          Olá, <strong>{customerName}</strong>! Seu pedido foi processado com sucesso.
                        </p>

                        <div
                          style={{
                            backgroundColor: "#FFD700",
                            borderRadius: "999px",
                            color: "#333333",
                            fontWeight: "bold",
                            fontSize: "14px",
                            padding: "10px 20px",
                            display: "inline-block"
                          }}
                        >
                          Pedido #{transactionId}
                        </div>
                      </div>

                      {/* Order Details Section */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "32px 0 16px",
                          lineHeight: "1.3"
                        }}
                      >
                        📋 Detalhes da Assinatura
                      </h2>

                      {/* Items List */}
                      <div
                        className="info-box"
                        style={{
                          border: "1px solid #e5e7eb",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "24px"
                        }}
                      >
                        {items.map((item, index) => (
                          <div key={index} style={{
                            paddingBottom: index < items.length - 1 ? "20px" : "0",
                            marginBottom: index < items.length - 1 ? "20px" : "0",
                            borderBottom: index < items.length - 1 ? "1px solid #e5e7eb" : "none"
                          }}>
                            <table width="100%" cellPadding={0} cellSpacing={0}>
                              <tbody>
                                <tr className="item-row">
                                  <td className="item-details" style={{ width: "70%", verticalAlign: "top" }}>
                                    <h3 style={{ 
                                      margin: "0 0 4px", 
                                      fontSize: "16px", 
                                      color: "#1F1746",
                                      fontWeight: "600"
                                    }}>
                                      {item.planName}
                                    </h3>
                                    <p style={{ 
                                      margin: "0 0 8px", 
                                      fontSize: "14px", 
                                      color: "#6b7280",
                                      lineHeight: "1.4"
                                    }}>
                                      {item.planDescription}
                                    </p>
                                    <div style={{ fontSize: "13px", color: "#6b7280" }}>
                                      <div style={{ marginBottom: "2px" }}>
                                        📅 <strong>Período:</strong> {item.billingPeriod}
                                      </div>
                                      <div>
                                        🔄 <strong>Próxima cobrança:</strong> {item.nextBillingDate}
                                      </div>
                                    </div>
                                  </td>
                                  <td className="item-price" style={{ 
                                    width: "30%", 
                                    textAlign: "right", 
                                    verticalAlign: "top",
                                    paddingLeft: "16px"
                                  }}>
                                    <div style={{ 
                                      fontSize: "18px", 
                                      fontWeight: "bold", 
                                      color: "#1F1746"
                                    }}>
                                      {item.price}
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        ))}

                        {/* Total */}
                        <div style={{
                          borderTop: "2px solid #1F1746",
                          paddingTop: "16px",
                          marginTop: "20px"
                        }}>
                          <table width="100%" cellPadding={0} cellSpacing={0}>
                            <tbody>
                              <tr>
                                <td style={{ textAlign: "right", paddingRight: "16px" }}>
                                  <span style={{ 
                                    fontSize: "16px", 
                                    fontWeight: "600", 
                                    color: "#1F1746"
                                  }}>
                                    Total da Assinatura:
                                  </span>
                                </td>
                                <td style={{ textAlign: "right", width: "30%" }}>
                                  <span style={{ 
                                    fontSize: "20px", 
                                    fontWeight: "bold", 
                                    color: "#1F1746"
                                  }}>
                                    {total}
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      {/* Account Information */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "32px 0 16px",
                          lineHeight: "1.3"
                        }}
                      >
                        👤 Informações da Conta
                      </h2>
                      <div
                        className="info-box"
                        style={{
                          border: "1px solid #e5e7eb",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "24px"
                        }}
                      >
                        <table width="100%" cellPadding={0} cellSpacing={0}>
                          <tbody>
                            <tr>
                              <td style={{ width: "70%" }}>
                                <div style={{ marginBottom: "8px" }}>
                                  <strong style={{ color: "#1F1746", fontSize: "14px" }}>Nome:</strong>
                                  <div style={{ color: "#374151", fontSize: "14px" }}>{customerName}</div>
                                </div>
                                <div>
                                  <strong style={{ color: "#1F1746", fontSize: "14px" }}>Email:</strong>
                                  <div style={{ color: "#374151", fontSize: "14px" }}>{email}</div>
                                </div>
                              </td>
                              <td style={{ width: "30%", textAlign: "right", verticalAlign: "top" }}>
                                <div style={{ fontSize: "13px", color: "#6b7280" }}>
                                  <strong>Data do pedido:</strong>
                                  <div>{purchaseDate}</div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/* Next Steps */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "32px 0 16px",
                          lineHeight: "1.3"
                        }}
                      >
                        🚀 Próximos Passos
                      </h2>
                      <div
                        className="info-box"
                        style={{
                          border: "1px solid #e5e7eb",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "24px"
                        }}
                      >
                        <p style={{ 
                          margin: "0 0 16px", 
                          fontSize: "14px", 
                          color: "#374151",
                          lineHeight: "1.6"
                        }}>
                          Você receberá acesso imediato à sua assinatura. Nossa equipe está à disposição caso precise de qualquer auxílio.
                        </p>
                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                          <a
                            href="https://csm.trivium.com.br"
                            className="btn btn-primary"
                            style={{
                              backgroundColor: "#1F1746",
                              color: "#ffffff",
                              textDecoration: "none",
                              padding: "14px 28px",
                              borderRadius: "8px",
                              fontSize: "16px",
                              fontWeight: "bold",
                              display: "inline-block",
                              cursor: "pointer",
                              transition: "background-color 0.3s ease"
                            }}
                          >
                            Acessar Minha Conta
                          </a>
                        </div>
                      </div>

                      {/* Support Contact */}
                      <div
                        className="contact-box"
                        style={{
                          border: "1px solid #e5e7eb",
                          borderRadius: "10px",
                          padding: "20px",
                          background: "#f9fafb",
                          textAlign: "center"
                        }}
                      >
                        <h2 
                          className="contact-title"
                          style={{ 
                            fontSize: "16px", 
                            color: "#111", 
                            margin: "0 0 12px"
                          }}
                        >
                          🤝 Precisa de ajuda? Entre em contato conosco:
                        </h2>
                        <p 
                          className="contact-info"
                          style={{ 
                            margin: 0, 
                            fontSize: "14px", 
                            color: "#374151", 
                            lineHeight: "1.6"
                          }}
                        >
                          ✉️ suporte@trivium.com.br
                          <br />📱 (11) 3181-5940
                        </p>
                        <p style={{ 
                          margin: "16px 0 0", 
                          fontSize: "14px", 
                          color: "#6b7280",
                          fontStyle: "italic"
                        }}>
                          Atenciosamente,<br />
                          Equipe {companyName}
                        </p>
                      </div>
                    </td>
                  </tr>

                  {/* Footer */}
                  <tr>
                    <EmailFooterV2 variant="clean" showContactInfo={true} />
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export { OrderConfirmationEmailV2 };
